<div class="col-xs-12 sp-5 height-full flex-column height-full" [ngClass]="ttClass">
    <ng-content></ng-content>
</div>
